import { memo } from "react";

import { DesignMagazineAboutHotelListContainer } from "./container";

type Props = {
	hotelID: string;
};

export const DesignMagazineAboutHotelList = memo(({ hotelID }: Props) => {
	return <DesignMagazineAboutHotelListContainer hotelID={hotelID} />;
});

DesignMagazineAboutHotelList.displayName = "DesignMagazineAboutHotelList";
